export const META_PIXEL_ID = '1643862547304500'

export const PRODUCT_CONTENT = {
  content_name: 'Speech Therapy Clinical Toolkit™',
  content_ids: ['speech-therapy-clinical-toolkit'],
  content_type: 'product',
  value: 27,
  currency: 'USD',
}

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

/** Injects the Meta Pixel base code once and fires PageView + ViewContent. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImage = document.createElement('img')
    pixelImage.height = 1
    pixelImage.width = 1
    pixelImage.style.display = 'none'
    pixelImage.alt = ''
    pixelImage.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImage)
    document.body.appendChild(noscript)

    window.fbq('init', META_PIXEL_ID)
  }

  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', PRODUCT_CONTENT)
}

export function trackInitiateCheckout(): void {
  window.fbq?.('track', 'InitiateCheckout', {
    ...PRODUCT_CONTENT,
    num_items: 1,
  })
}
